

$(document).ready(function (event) {
    //event.stopImmediatePropagation();
    $('.image-button').magnificPopup({
        type: 'image'
    });

    // Attach on document, so it also works for dynamically loaded content
    $(document).on("getItemsSucceeded", ".PictureWall", function (event, markupAdded) {
        if (markupAdded) {
            $('.image-button').magnificPopup({
                type: 'image'
            });
        }
    });
});

